const baseRoute = 'solventa/home'

/* THIS LEVEL WILL BE DEPRECATED WHEN ALL THE USERS UPDATES TO LEVEL 1 */
export const LEVEL_0_ROUTES = {
  INVITATION: 'solventa/invitation/confirmation',
  FIRST_TIME: `${baseRoute}/first-time`,
  EVALUATION_LOAN_REQUEST: `${baseRoute}/evaluating-loan-request`,
  USER_NOT_APPLICABLE: `${baseRoute}/user-not-applicable`,
  LOAN_REQUEST_DENIED: `${baseRoute}/loan-request-denied`,
  LOAN_REQUEST_ACCEPTED: `${baseRoute}/loan-request-accepted`,
  EVALUATING_LOAN: `${baseRoute}/evaluating-loan`,
  DECLINED_LOAN: `${baseRoute}/loan-declined`,
  ACTIVE_LOAN: `${baseRoute}/active-loan`,
  EVALUATING_PAYMENT: `${baseRoute}/active-loan`,
  PAYMENT_DECLINED: `${baseRoute}/active-loan`,
  SETTING_CUSTOM_CREDIT: `${baseRoute}/active-loan`,
  SOLVENTA: `${baseRoute}/active-loan`,
  WAITING_LOAN: `${baseRoute}/waiting-loan`,
}
